<template>
  <div class="pc-skeleton-sign-up pc-skeleton-sign-up--payment">
    <!-- <div class="gc-header-subscription pc-sign-up-register__header-subscription">
      <AnimatedPlaceholder height="64px" width="180px" />
    </div> -->

<div class="gc-page__container-fluid container-fluid p-0 m-0">
  <div class="row no-gutters">
    <div class="col-md-12 col-lg-4">
      <div class="gc-card-subscription-cover-image pc-sign-up-register__subscription-cover-image">
        <AnimatedPlaceholder width="100%" height="100%" border-radius="0"/>
      </div>
    </div>
    <div class="pc-sign-up-register__content-col col-md-12 col-lg-8">
      <div class="container gc-page__container pc-sign-up-register__container container-sm">
        <div class="pc-sign-up-register__intro">
          <AnimatedPlaceholder width="100%"  />
          <AnimatedPlaceholder width="100%"  />
          <AnimatedPlaceholder width="100%"  />
          <AnimatedPlaceholder width="100px" />
        </div>
        <div class="pc-sign-up-register__plan">
          <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="200px" height="18px" />
          <div >
            <AnimatedPlaceholder width="100%" height="124px" border-radius="10px"/>
          </div>
          <div class="pc-skeleton-sign-up__input">
            <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="200px" height="25px" />
            <AnimatedPlaceholder width="100%" height="40px" />
          </div>
          <div class="pc-skeleton-sign-up__inpu-second-section">
            <div class="pc-skeleton-sign-up__input">
              <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="200px" height="16px" />
              <AnimatedPlaceholder width="100%" height="60px" />
            </div>
            <div class="pc-skeleton-sign-up__input">
              <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="200px" height="16px" />
              <AnimatedPlaceholder width="100%" height="60px" />
            </div>
            <div class="container p-0" >
              <div class="pc-skeleton-sign-up__input--two row">
                <div class="pc-skeleton-sign-up__input col-6">
                  <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="100px" height="16px" />
                  <AnimatedPlaceholder width="100%" height="60px" />
                </div>
                <div class="pc-skeleton-sign-up__input col-6">
                  <AnimatedPlaceholder class="pc-sign-up-register__plan-title" width="100px" height="16px" />
                  <AnimatedPlaceholder width="100%" height="60px" />
                </div>
              </div>
            </div>
          </div>
          
          
          
        
        </div>
      </div>
    </div>
  </div>
</div>
    
 
   
  </div>
</template>

<script >
import AnimatedPlaceholder from '@/components/global/animators/AnimatedPlaceholder';

export default {
    components: {
      AnimatedPlaceholder
    }
}
</script>
  
<style>


</style>